import React, { useState } from 'react';
import Button from '@mui/material/Button';
import './footer.scss';
import { FaChevronDown, FaChevronUp, FaFacebook, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { FaSquareXTwitter } from 'react-icons/fa6';
import { determineAppEnvironment } from "../EzEnviornmentInfo/EzEnviornmentInfo";
import '../../assets/styles/ez-border.scss';
import '../../assets/styles/ez-color.scss';
import '../../assets/styles/ez-margin.scss';
import '../../assets/styles/ez-fonts.scss';
import { aboutNavigationItems } from './aboutEzclocker-navigation';
import { marketingNavigationItems } from './marketing-navigation-items';
import { blogNavigationItems } from './blog-navigation-items';
import { industryNavigationMenu } from './industry-footer-navigation-menu';
import { productNavigationMenu } from './product-footer-navigation-menu';
import { Link } from 'react-router';

const Footer = () => {
    const redirectDomain = determineAppEnvironment();

    const [aboutEzclockerDropDown, setAboutEzclockerDropDown] = useState(false);

    const [productDropDown, setProductDropDown] = useState(false);

    const [industriesDropdown, setIndustriesDropdown] = useState(false);

    return (
        <footer id="ezcFooter">
            <div className="footer-links-section border-top-orange">
                <div className="non-responsive">
                    <div>
                        <ul className="collapse" id="aboutfoot">
                            {
                                aboutNavigationItems.map(
                                    (aboutLink, index) => {
                                        return (
                                            <li key={aboutLink.key}>
                                                <Link className="footer-links" to={aboutLink.link}>
                                                    {aboutLink.title}
                                                </Link>
                                            </li>);
                                    })
                            }
                            {
                                marketingNavigationItems.map(
                                    (marketingLink, index) => {
                                        return (
                                            <li key={marketingLink.key}>
                                                <a className="footer-links" href={`${redirectDomain}${marketingLink.link}`}>
                                                    {marketingLink.title}
                                                </a>
                                            </li>);
                                    })
                            }
                            {
                                blogNavigationItems.map(
                                    (blogLink, index) => {
                                        const redirectUrl = blogLink.link.startsWith('http')
                                            ? blogLink.link
                                            : `${redirectDomain}${blogLink.link}`;

                                        return (
                                            <li key={blogLink.key}>
                                                <Button variant="text" className="footer-link" onClick={() => (window.location.href = redirectUrl)}>
                                                    {blogLink.title}
                                                </Button>
                                            </li>);
                                    })
                            }
                        </ul>
                    </div>
                    <div className="margin-left-30">
                        <ul className="collapse" id="productfoot">
                            {
                                productNavigationMenu.map(
                                    (productMap, index) => {

                                        return (
                                            <li key={index}>
                                                <Link className="footer-links" to={productMap.link}>
                                                    {productMap.title}
                                                </Link>
                                            </li>);
                                    })
                            }
                        </ul>
                    </div>
                    <div className="margin-left-30">
                        <ul className="collapse" id="indusfoot">
                            {
                                industryNavigationMenu.map(
                                    (industry, index) => {
                                        const redirectUrl = industry.link.startsWith('http')
                                            ? industry.link
                                            : `${redirectDomain}${industry.link}`;

                                        return (
                                            <li key={index}>
                                                <Button variant="text" className="footer-link" onClick={() => (window.location.href = redirectUrl)}>
                                                    {industry.title}
                                                </Button>
                                            </li>);
                                    })
                            }
                        </ul>
                    </div>
                </div>
                <div className="responsive">
                    <div className="footer-responsive-main-link color-dull-white">
                        <Button
                            variant="text"
                            className="responsive-links-button background-color-transparent color-dull-white border-none font-size-20 font-weight-bold"
                            onClick={() => setAboutEzclockerDropDown((prev) => !prev)}>
                            About ezClocker
                        </Button>
                        {
                            !aboutEzclockerDropDown && (<FaChevronDown className="faChevron" onClick={() => setAboutEzclockerDropDown((prev) => !prev)} />)
                        }
                        {
                            aboutEzclockerDropDown && (<FaChevronUp className="faChevron" onClick={() => setAboutEzclockerDropDown((prev) => !prev)} />)
                        }
                    </div>
                    <ul className={`${aboutEzclockerDropDown ? 'ezclocker-dropdown-show' : 'ezclocker-dropdown-hide'}`}>
                        {
                            aboutNavigationItems.map(
                                (aboutLink, index) => {
                                    return (
                                        <li key={aboutLink.key}>
                                            <Link className="footer-links" to={aboutLink.link}>
                                                {aboutLink.title}
                                            </Link>
                                        </li>);
                                })
                        }
                        {
                            marketingNavigationItems.map(
                                (marketingLink, index) => {
                                    return (
                                        <li key={marketingLink.key}>
                                            <a className="footer-links" href={`${redirectDomain}${marketingLink.link}`}>
                                                {marketingLink.title}
                                            </a>
                                        </li>);
                                })
                        }
                        {
                            blogNavigationItems.map(
                                (blogLink, index) => {
                                    return (
                                        <li key={blogLink.key}>
                                            <Link className="footer-links" to={blogLink.link}>
                                                {blogLink.title}
                                            </Link>
                                        </li>);
                                })
                        }
                    </ul>
                    <div className="footer-responsive-main-link color-dull-white">
                        <Button
                            variant="text"
                            className="responsive-links-button background-color-transparent border-none color-dull-white font-size-20 font-weight-bold"
                            onClick={() => setProductDropDown((prev) => !prev)}>
                            Product
                        </Button>
                        {
                            !productDropDown && (<FaChevronDown className="faChevron" onClick={() => setProductDropDown((prev) => !prev)} />)
                        }
                        {
                            productDropDown && (<FaChevronUp className="faChevron" onClick={() => setProductDropDown((prev) => !prev)} />)
                        }
                    </div>
                    <ul className={`${productDropDown ? 'product-dropdown-show' : 'product-dropdown-hide'}`}>
                        {
                            productNavigationMenu.map(
                                (product, index) => {
                                    return (
                                        <li key={index}>
                                            <Link className="footer-links" to={product.link}>
                                                {product.title}
                                            </Link>
                                        </li>);
                                })
                        }
                    </ul>
                    <div className="footer-responsive-main-link color-dull-white">
                        <Button
                            variant="text"
                            className="responsive-links-button background-color-transparent border-none color-dull-white font-size-20 font-weight-bold"
                            onClick={() => setIndustriesDropdown((prev) => !prev)}>
                            Industries
                        </Button>
                        {
                            !industriesDropdown && (<FaChevronDown className="faChevron" onClick={() => setIndustriesDropdown((prev) => !prev)} />)
                        }
                        {
                            industriesDropdown && (<FaChevronUp className="faChevron" onClick={() => setIndustriesDropdown((prev) => !prev)} />)
                        }
                    </div>
                    <ul className={`${industriesDropdown ? 'industries-dropdown-show' : 'industries-dropdown-hide'}`}>
                        {
                            industryNavigationMenu.map(
                                (industryLink, index) => {
                                    return (
                                        <li key={industryLink.key}>
                                            <Button
                                                variant="text"
                                                className="footer-link"
                                                onClick={() => (window.location.href = `${redirectDomain}${industryLink.link}`)}>
                                                {industryLink.title}
                                            </Button>
                                        </li>);
                                })
                        }
                    </ul>
                </div>
                <div className="social-networks margin-left-30">
                    <Button variant="text" className="twitter footer-link" onClick={() => (window.location.href = 'https://twitter.com/ezClocker')}>
                        <FaSquareXTwitter />
                    </Button>
                    <Button variant="text" className="facebook footer-link" onClick={() => (window.location.href = 'https://www.facebook.com/ezClockerApp')}>
                        <FaFacebook />
                    </Button>
                    <Button
                        variant="text"
                        className="google footer-link"
                        onClick={() => (window.location.href = 'https://www.linkedin.com/company/ezclocker/')}>
                        <FaLinkedin />
                    </Button>
                    <Button variant="text" className="google footer-link" onClick={() => (window.location.href = 'https://www.youtube.com/@ezclocker')}>
                        <FaYoutube />
                    </Button>
                    <div className="contact-us-button-container">
                        <Button
                            id="EzEzContactUsButton"
                            className="contact-us-button"
                            onClick={() => (window.location.href = `${redirectDomain}/welcome/contact.html`)}>
                            Contact us
                        </Button>
                    </div>
                </div>
                <div className="margin-left-30">
                    <div className="apple-store-social-networks">
                        <Button
                            variant="text"
                            className="footer-link"
                            onClick={() => (window.location.href = 'https://itunes.apple.com/us/developer/eznova-technologies-llc/id800807200')}>
                            <img
                                className="appleAppStoreBadge color-dull-white"
                                id="appleAppStoreBadge"
                                alt="Download from Apple App Store"
                                src="https://s3.amazonaws.com/com.ezclocker.images/marketing/apple-appstore.svg" />
                        </Button>
                    </div>
                    <div className="google-play-social-networks">
                        <Button
                            variant="text"
                            className="footer-link"
                            onClick={() => (window.location.href = 'https://play.google.com/store/apps/details?id=com.ezclocker')}>
                            <img
                                alt="Get it on Google Play"
                                src="https://play.google.com/intl/en_us/badges/images/badge_new.png" />
                        </Button>
                    </div>
                </div>
            </div>
            <div className="footer-copyright color-white background-color-dark-dull-blue">
                <p>6010 W. Spring Creek Pkwy Plano, TX 75024 Suite G</p>
                <p>© EzNova Technologies LLC. All Rights Reserved.</p>
                <Link className="browserInfoLink" to="/browser-info">
                    About Your Browser
                </Link>
            </div>
        </footer>);
};

export default Footer;
